import React, {FC} from "react"

import id from "@irati/utils/id"

import {getProfileImage} from "@irati/utils/images"
import {User} from "@irati/types"

import DefaultProfilePicture from "./DefaultProfilePicture"
import {Img} from "./styled"

export interface ProfilePictureProps {
  user: User,
  size?: number,
  small?: boolean,
  regular?: boolean,
  large?: boolean,
  deactivated?: boolean,
  border?: boolean,
  defaultImageOverride?: string,
  id?: string,
  marginRight?: boolean
}

const ProfilePicture: FC<ProfilePictureProps> = ({size, ...props}) => {
  const {user, deactivated, border, defaultImageOverride, marginRight} = props

  const idNamespace = id("profile-picture", props)

  const profileImg = user.profileImageUrl || user.profile_img
  const firstName = user.firstName || user.firstname
  const lastName = user.lastName || user.lastname

  const getPictureSize = () => {
    const {small, regular, large} = props

    if (small) return 30
    else if (regular) return 50
    else if (large) return 100

    return undefined
  }

  return profileImg ? (
    <Img
      id={id("img", idNamespace)}
      size={getPictureSize() || size}
      deactivated={deactivated}
      border={border}
      src={getProfileImage(profileImg, defaultImageOverride)}
      alt="profile_img"
      marginRight={marginRight} />
  ) : (
    <DefaultProfilePicture
      id={idNamespace}
      deactivated={deactivated}
      firstname={firstName}
      lastname={lastName}
      size={getPictureSize() || size}
      border={border}
      marginRight={marginRight} />
  )
}

export default ProfilePicture
